let quickShopSlider = null;
/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
  * prevent body Touch event in Touch devices when Overlay is visible
  *
  * @param {event} event - event instance
*/
function bodyTouchMove(event){
  let currentTarget = event.target;
  if (!currentTarget.closest('[data-touch-moveable]')) {
    event.preventDefault();
    return false;
  }
}

/**
  * Limit the number of times a function is called within defined timeout
  *
  * @param {form} form - Form to serialize
*/
const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

const formDataToQueryString = formData => {
  let queryString = '';
  console.log(formData,'formDataformData')
  for (const [key, value] of formData.entries()) {
      if (queryString.length > 0) {
          queryString += '&';
      }
      queryString += encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }
  return queryString;
}


/**
  * Fetch call config
  *
  * @param {string} type - request Accept type
*/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 function dropDownInit(element){
 
  const dropdownParent = element.parentElement;
  const dropdownEle = element;
 
  ["click"].forEach(function(type){
    if(type == 'click'){
      dropdownEle.addEventListener(type, (evt) => {
        evt.preventDefault();
        let currentTarget = evt.currentTarget;
        if (currentTarget.closest('.dropdown').classList.contains('open')){
          dropdownToggle(dropdownParent);
          siteOverlay.prototype.hideOverlay();

          document.querySelector('body').classList.remove('Mega_menu');
        } else {
          document.querySelectorAll('.dropdown.open').forEach(ele => { ele.classList.remove('open'); });
          dropdownToggle(dropdownParent);
          siteOverlay.prototype.showOverlay();

          document.querySelector('body').classList.add('Mega_menu');
        }
      });
    }else if(type == 'mouseout'){
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest('[data-touch-moveable]');
        if(!mobileContainer){
          dropdownHide(dropdownParent);
        }
      }, true);
    } else if(type == 'mouseover' || type == 'focusin'){
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest('[data-touch-moveable]');
        if(!mobileContainer){
          dropdownShow(dropdownParent); 
        }
      });
      dropdownEle.addEventListener(type, (e) => { ChildonFocusChange(dropdownParent); });
    }
  });

  dropdownParent.addEventListener('keyup', (event) => {
    if (event.code) {
      if (event.code.toUpperCase() === 'ESCAPE'){ dropdownHide(event.currentTarget, event.type); }
      if (event.code.toUpperCase() === 'ENTER'){ dropdownShow(event.currentTarget); }
    }
  });

  function dropdownToggle(dropdownParent) {
    let isActive = dropdownParent.classList.contains('open');
    setTimeout(function(){
        if (!isActive) { 
            if (dropdownParent.classList.contains('second-level')) {
                document.querySelector('#mobile-menu-drawer').classList.add('secondD__active');
            } 
            dropdownShow(dropdownParent); 
        } else if (isActive) { 
            if (dropdownParent.classList.contains('second-level')) {
                document.querySelector('#mobile-menu-drawer').classList.remove('secondD__active');
            }
            dropdownHide(dropdownParent); 
        }
    }, 50);
  }

  function dropdownShow(dropdownParent){
    if(!dropdownParent){
      return;
    }

    dropdownEle.setAttribute('aria-expanded', true);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.add('open');
    }else{
      Utility.toggleElement(dropdownParent, 'open');
    }
  }

  function dropdownHide(dropdownParent, eventType){
    if(!dropdownParent){
      return;
    }

    dropdownEle.setAttribute('aria-expanded', false);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.remove('open');
      // document.querySelector('body').classList.remove('scroll-fixed');
      document.querySelector('body').classList.remove('scroll-fixed-custome');
      document.querySelector('body').classList.remove('Mega_menu');
    }else{
      Utility.toggleElement(dropdownParent, 'close');
    }

    if(eventType == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')){
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if(childDropdowns.length > 0){
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        if(child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  function ChildonFocusChange(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if(eleIndex != currentIndex){ dropdownHide(ele); }
    });
  }

  let closeBtn = dropdownParent.querySelector('.close-submenu');
  if(closeBtn){
    closeBtn.addEventListener('click', (event)=>{
      event.preventDefault();
      let parentElement = event.currentTarget.closest('.dropdown');
      dropdownToggle(parentElement);
    });
  };
}

const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function(ele) {
  dropDownInit(ele)
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element){
  let _this = element;
  ["click"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      e.stopPropagation();
      let currentTarget = e.currentTarget;
      if(!currentTarget.closest('[data-touch-moveable]')){
        hideDropdown(_this.parentElement);
      }
    });
  });

  _this.addEventListener('touchend', (e) => {
    e.stopPropagation();
  });
  
  function hideDropdown(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele?.querySelector('[is="drop-down"]')?.setAttribute('aria-expanded', false);
    });
  }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function(ele) {
  defaultNavItem(ele);
});

/**
* Website Overlay for Mobile Menu and Cart Drawer
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('#ajax-cart');
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    if(this.cartDrawer && this.cartDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    if(this.menuDrawer && this.menuDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    }
    if (!document.querySelector('.state-dropdown.open')) {
      this.hideOverlay();
    }
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.getElementById('site-overlay').classList.add('overlay--body');
    document.querySelector('body').classList.add('scroll-fixed');
    document.body.style.overflowY = "hidden";
    // document.body.addEventListener('touchmove', bodyTouchMove, false);
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.getElementById('site-overlay').classList.remove('overlay--body');
    document.querySelector('body').classList.remove('scroll-fixed');
    document.body.style.overflowY = "auto";
    document.querySelector('body').classList.remove('Mega_menu');
    document.querySelector('custom-select.sort-active')?.classList.remove('sort-active');
    document.querySelectorAll(".megamenu").forEach(element => {
      if (element.classList.contains('open')) {
        element.classList.remove('open');
      }
    })
    try{
      document.querySelector('search-modal')?.close();
    }catch(err){
      console.log(err,'error')
    }
  }
}
customElements.define("site-overlay", siteOverlay);

/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    
    this.triggerVideo = this.container.querySelector('[data-trigger-video]');
    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');

    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.placementType == 'grid' ) this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    if(this.placementType == 'popup' && this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(evt){
    let isOpen = this.container.classList.contains('playing--video');
    if(isOpen){
      this.videoSection.innerHTML = '';
      this.container.classList.remove('playing--video');
    }else{
      if(typeof YT == 'undefined' && this.type == 'youtube'){
        let youtubeScript = document.createElement('script');
        youtubeScript.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(youtubeScript);
      }

      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);;
      this.videoSection.appendChild(videoElement);

      const addClassInterval = setInterval(()=> {
        if (this.videoSection.innerHTML != ''){
          if(this.placementType == 'popup'){ 
            openModal(this.videoModal, this.triggerVideo);
          }else{
            this.container.classList.add('playing--video');
          }
          clearInterval(addClassInterval); 
        } 
      }, 500);

      if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
      if(this.placementType == 'grid' && (this.type == 'local' || this.type == 'youtube')){
        this.videoPauseOnScroll();
      }
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      video.controls = this.dataset.controls;
      video.muted = this.dataset.muted;
      video.autoplay = this.dataset.autoplay;
      video.loop = this.dataset.loop;
    }else if(this.type == 'youtube'){
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }else if(this.type == 'vimeo'){
      let videoID = this.videoURL.replace('https://vimeo.com/','');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      if(this.dataset.autoplay) video.setAttribute("allow", "autoplay");
      video.setAttribute( "src", "https://player.vimeo.com/video/"+ videoID + `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}`);
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  videoPauseOnScroll(){
    let videoEle = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    let observer = new IntersectionObserver((entries, observer) => { 
      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local'){
            videoEle.pause();
          }else if(this.type == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    observer.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const onIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let dataSrc = entry.target.dataset.src;
          var videoSource = document.createElement('source');
          videoSource.src = dataSrc;
          videoSource.type = "video/mp4";
          entry.target.appendChild(videoSource)
          entry.target.play();
          observerPosterVideo.disconnect();         
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(onIntersection);
    if(posterVideo != undefined) observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
  }

  connectedCallback() {
    if(this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener)=>{
        opener.addEventListener('click', ()=>{
          this.show(opener);
        });
      });
    }

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (evt) => {
      if (evt.target.nodeName === 'MODAL-DIALOG') this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);


/**
  * Set root variable for mobile navigation top
  * Submenu Body click event to stop closing second level
*/
(function updateTopinRoot(){
  try{
    let headerEle = document.querySelector('.section-header');
  
    if(headerEle != undefined){
      let headerHeight = headerEle.clientHeight;
      document.querySelector(':root').style.setProperty('--bs-navdrawer',`${headerHeight}px`);
      document.querySelector(':root').style.setProperty('--bs-mobile-navdrawer',`${headerHeight}px`);
    }
    let topbarEle = document.querySelector('.top-header');
    if(topbarEle != undefined){
      let topbarHeight = topbarEle.clientHeight;
      document.documentElement.style.setProperty('--bs-topbar-height',`${topbarHeight}px`);
    }
  }catch(err){
    console.error(err,'error')
    Utility._rollBar(err)
  }
  
})()

try{
  document.addEventListener('DOMContentLoaded', function() {
    const home_playvideo = document.querySelectorAll('[data-video-btn]');
    home_playvideo.forEach((ele) => {
      ele.addEventListener('click', (event) => {
        // Toggle mute/unmute directly
        let videoEle = ele.closest('[data-video-parent]').querySelector('video')
        document.querySelectorAll('[data-video-parent]').forEach((element)=>{
          if (videoEle != element.querySelector('video')) {
            element.classList.remove('video-play');
            element.querySelector('video').muted = true;
          }
        })
        if (videoEle) {
          if(videoEle.muted){
            videoEle.muted = false;
            ele.closest('[data-video-parent]').classList.add('video-play');
          }else{
            videoEle.muted = true;
            ele.closest('[data-video-parent]').classList.remove('video-play');
          }
        }
      });
    });
  });
}catch(err){
  console.error(err,'error')
  Utility._rollBar(err)
}

try{
  const tablinks = document.querySelectorAll('custom-tabs [data-collection-handle]');
  tablinks.forEach((link)=>{
    link.addEventListener('click',()=>{
      let url = link.getAttribute('data-collection-handle');
      let text = link.innerText.toLowerCase()
      let btn = document.querySelectorAll('[data-slider-button]');
      if (btn.length && url) {
        btn.forEach((btnEle)=>{
          btnEle.setAttribute('href',url);
          btnEle.textContent = `Shop All ${text}`
        })
      }
    })
  })
}catch(err){
  console.error(err,'error')
  Utility._rollBar(err)
}


if (window.location.href.includes('contact') || window.location.href.includes('order-tracking-form')) {
  let interval=setInterval(() => {
      if (document.querySelector('.form-content')) {
        document.querySelector('.form-content').style.opacity = '1';
        const form = document.querySelector('.order-form');
        const title = document.getElementById('search-form-title');
        const sub_title = document.createElement('h2');
        title.textContent = sub_title.textContent;
        title.parentNode.replaceChild(sub_title, title);
        const subtitle = document.createElement('p');
        const email = document.querySelector('.order-track-input[name="email"]');
        const order = document.querySelector('input[name="order_number"');
        const inputs = document.querySelector('.order-track-form');
        form.style.backgroundColor = 'transparent';
        form.style.boxShadow = 'unset';
        sub_title.textContent = 'Track Your Order';
        subtitle.textContent = `To track your order please enter your Order ID in the box below and
        click the "Track" button. This was given to you on your receipt and
        in the confirmation email you should have received.`;
        sub_title.insertAdjacentElement('afterend', subtitle);
        email.placeholder = 'Billing Email (Email Used During Checkout)';
        order.placeholder = 'Order ID (Found In Your Order Confirmation)';
        sub_title.style.textAlign = 'left';
        subtitle.style.fontSize = '16px';
        subtitle.style.textAlign = 'left';
        subtitle.style.fontWeight = '400';
        subtitle.style.lineHeight = '1.75';
        email.style.backgroundColor = 'transparent';
        order.style.backgroundColor = 'transparent';
        inputs.style.border = 'unset';
      clearInterval(interval)
      }
    })
}

// On iPhone, when we click on any input, The page zoom issue is fixed now
if(navigator.userAgent.indexOf('iPhone') > -1 ){
  document.querySelector("[name=viewport]").setAttribute("content","width=device-width, initial-scale=1, maximum-scale=1");
}

// Function to add class based on "snize-product-label" innerText
function updateClasses() {
  console.log('updateClasses')
  document.querySelectorAll('.snize-product-label').forEach(label => {
      const badgeName = label.innerText
      const className = label.innerText.trim().toLowerCase().replace(/\s+/g, '-');
      const closestLi = label.closest('li');
      if (closestLi) {
        closestLi.classList.add(className);
      }
      const iconHtml = document.querySelector(`[data-badge-name="${className}"]`)?.innerHTML
      const newHtml = (iconHtml ? iconHtml : '') + badgeName
      label.innerHTML = newHtml
  });
}

let badgeInterval;

function controlBadgeInterval(activate) {
  const isSearchResultsPage = window.location.href.includes('search-results-page');
  
  if ((isSearchResultsPage || activate) && !badgeInterval) {
    badgeInterval = setInterval(() => {
      updateClasses();
    }, 500);
  } else if (!activate && badgeInterval) {
    clearInterval(badgeInterval);
    badgeInterval = null;
  }
}

controlBadgeInterval();

/**
 * Description content toggle functionality
 */
// Check if the custom element 'description-toggle' is not already registered
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-read-more-toggle]").forEach(toggle => {
      let descContent = toggle.previousElementSibling; // Get the content div

      toggle.addEventListener("click", function () {
          let isExpanded = descContent.classList.contains("expanded");

          if (isExpanded) {
              // Collapse
              descContent.classList.remove("expanded");
              this.innerText = "Read More";
          } else {
              // Store full height before expanding
              descContent.style.setProperty("--full-height", descContent.scrollHeight + "px");
              descContent.classList.add("expanded");
              this.innerText = "Read Less";
          }
      });
  });
});



/**
 * Change the link of login page to account page in /tools/recurring/login/ 
 */
if (window.location.href.includes('/tools/recurring/login/')) {
  document.querySelector('#customer_tab_content [href="/account/login"]')?.setAttribute('href','/account');
  let rawText = document.querySelector('#customer_tab_content .rc_header-settings__description')?.innerHTML;
  if (rawText) {
    document.querySelector('#customer_tab_content .rc_header-settings__description').innerHTML = Utility.convertToAnchor(rawText);
  }
}